import { LayoutEditForm } from "./LayoutEditForm";
import { LayoutSubgrid } from './LayoutSubgrid';
import { LayoutViewBlock } from './LayoutViewBlock';

export * from "./LayoutRow";
export * from "./LayoutBlock";
export * from "./LayoutEditForm";
export * from "./LayoutViewBlock";
export * from './LayoutSubgrid';


export class Layout {
    public EditForm: LayoutEditForm;
    public Dashboard: LayoutEditForm;
    public Subgrids: LayoutSubgrid[];
    public ViewBlocks: LayoutViewBlock[];
    public AfterPageLoadScript: string = "";
}

